// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PropertyImage {
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;
  flex-wrap: wrap;
}
.PropertyImage__Wrapper {
  display: flex;
  justify-content: center;
  flex: 1;
  flex-basis: 100%;
  width: 100%;
  height: 100%;
  min-height: 2rem;
  min-width: 2rem;
}
.PropertyImage__Image, .PropertyImage__Carousel {
  width: 100%;
  min-height: 4rem;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}
.PropertyImage__Button {
  margin-top: 1rem;
  width: 40%;
  min-width: 10rem;
}
.PropertyImage__UploadWarning {
  margin-top: 1rem;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./libs/features/shared/components/src/lib/property-image/property-image.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,eAAA;AACF;AACE;EACE,aAAA;EACA,uBAAA;EACA,OAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;AACJ;AAEE;EAEE,WAAA;EACA,gBAAA;EACA,wBAAA;EACA,4BAAA;EACA,2BAAA;AADJ;AAKE;EACE,gBAAA;EACA,UAAA;EACA,gBAAA;AAHJ;AAME;EACE,gBAAA;EACA,kBAAA;AAJJ","sourcesContent":[".PropertyImage {\n  display: flex;\n  width: 100%;\n  height: 100%;\n  justify-content: center;\n  flex-wrap: wrap;\n\n  &__Wrapper {\n    display: flex;\n    justify-content: center;\n    flex: 1;\n    flex-basis: 100%;\n    width: 100%;\n    height: 100%;\n    min-height: 2rem;\n    min-width: 2rem;\n  }\n\n  &__Image,\n  &__Carousel {\n    width: 100%;\n    min-height: 4rem;\n    background-size: contain;\n    background-repeat: no-repeat;\n    background-position: center;\n    // padding: 30%; // makes a square image\n  }\n\n  &__Button {\n    margin-top: 1rem;\n    width: 40%;\n    min-width: 10rem;\n  }\n\n  &__UploadWarning {\n    margin-top: 1rem;\n    text-align: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
